<template lang="pug">
#eventsSorting.modal.modal-common.animated.fadeInUp1.modal-bottom(tabindex="-1" role="dialog" aria-labelledby="eventsSorting" aria-hidden="true")
  .modal-dialog.modal-dialog-scrollable.m-0(role="document")
    .modal-content
      .modal-header(data-dismiss="modal" aria-label="Close")
        .icon
          i.fas.fa-arrow-left
        h5#exampleModalLabel.modal-title {{ $t("ui.default_event_sorting") }}
      .modal-body.p-0
        ul.list-group.setting(v-for="(item,index) in eventSorting")
          li.list-group-item(:class="{active: defaultEventSorting == index+1}" @click="setDefaultEventSorting(index+1)")
            span {{ $t(item) }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";

export default {
  data: () => ({
    eventSorting: ["ui.normal_sorting", "ui.sort_by_time"]
  }),
  computed: {
    defaultEventSorting() {
      return this.$store.getters.pageDisplay.eventSorting;
    },
    pageDisplay() {
      return this.$store.getters.pageDisplay;
    },
    betting() {
      return this.$store.getters.betting;
    },
    order() {
      return this.$store.state.layout.order.sports;
    },
  },
  methods: {
    setDefaultEventSorting(s) {
      // this.$store.dispatch("layout/setSinglePageDisplay", {property: "eventSorting", value: s.toString()});
      // EventBus.$emit("DEFAULT_EVENT_SORTING");
      // $('#eventsSorting').modal('hide');

      this.$store
        .dispatch("user/setSettings", {
          page_display: JSON.stringify({
            language: this.pageDisplay.language,
            oddsType: this.pageDisplay.oddsType,
            pageType: this.pageDisplay.pageType,
            showScoreMap: this.pageDisplay.showScoreMap,
            eventSorting: s.toString(),
            marketType: this.pageDisplay.marketType,
            pageSize: this.pageDisplay.pageSize,
            mmoType: this.pageDisplay.mmoType,
          }),
          sports_order: JSON.stringify(this.order),
          betting: JSON.stringify({
            defaultStake: this.betting.defaultStake,
            acceptBetterOdds: this.betting.acceptBetterOdds,
            acceptAnyOdds: this.betting.acceptAnyOdds,
            autoRefreshOdds: this.betting.autoRefreshOdds,
            quickBet: this.betting.quickBet,
            defaultStakeAmount: this.betting.defaultStakeAmount,
            quickBetAmount: this.betting.quickBetAmount,
          }),
        })
        .then(
          (res) => {
            this.$store.dispatch("layout/setSinglePageDisplay", {property: "eventSorting", value: s.toString()}).then(
              (res) => {
                this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.succeed"), "success");
              },
              (err) => {
                this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.failed"), "error");
              }
            );
            EventBus.$emit("DEFAULT_EVENT_SORTING");
            $('#eventsSorting').modal('hide');
          },
          (err) => {
            this.$helpers.showDialog(this.$t("ui.action"), this.$t("message.failed"), "error");
            EventBus.$emit("DEFAULT_EVENT_SORTING");
            $('#eventsSorting').modal('hide');
          }
        );
    }
  }
}
</script>